@use "../../../styles/tokens";
@use "../../../styles/responsive";
@use "../../../styles/accessibility";

.modal {
  --ixf-modal-max-width: 640px;
  --ixf-modal-max-height: 85vh;

  background-color: var(--ixf-color-background);
  border-radius: var(--ixf-border-radius-4);
  box-shadow: var(--ixf-box-shadow-modal);
  position: fixed;
  z-index: 9999;
  max-height: var(--ixf-modal-max-height);
  padding: var(--ixf-dialog-padding-vertical) 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: var(--ixf-modal-max-width);
  will-change: bottom;

  &.withoutAnimation {
    left: 50%;
    bottom: 50%;
    transform: translate(-50%, 50%);
  }

  @keyframes prevent-ios-focus-scroll {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  input:focus {
    animation: prevent-ios-focus-scroll 0.01s;
  }

  .withScrollingContent {
    overflow: hidden;
  }

  .contentContainer {
    overflow: auto;
    padding: 0 var(--ixf-dialog-padding-horizontal);
  }

  @media (max-width: tokens.$breakpoint-sm) {
    width: calc(100% - (var(--ixf-space-4) * 2));
    --ixf-modal-max-height: calc(100vh - (var(--ixf-space-4) * 2));
  }

  .visuallyHidden {
    @include accessibility.visually-hidden;
  }

  &.variant-simple {
    &.content-padding-compact {
      padding: 0;

      .contentContainer {
        padding: var(--ixf-space-4);
      }
    }

    .contentContainer {
      padding: var(--ixf-dialog-padding-vertical)
        var(--ixf-dialog-padding-horizontal) 0
        var(--ixf-dialog-padding-horizontal);
    }
  }
}

.overlay {
  background-color: var(--ixf-color-blackout-dk);
  position: fixed;
  inset: 0;
  z-index: 999;
}
